import 'bootstrap/js/dist/collapse';

if (module.hot) {
  module.hot.accept();
}